import gatewayService from '@/modules/common/services/gatewayService';

const BASE = 'business/communication/channels';

/**
 * Unwrap a comm-gw response. comm-gw nests under `data` per @vcita/infra-nestjs;
 * defensively support both `data.data.channels` and `data.channels`.
 */
function unwrapList(res) {
  const body = res?.data ?? {};
  const list = body?.data?.channels ?? body?.channels ?? [];
  return Array.isArray(list) ? list : [];
}

function unwrapChannel(res) {
  const body = res?.data ?? {};
  return body?.data?.channel ?? body?.channel ?? null;
}

/**
 * List every channel owned by the authenticated business (excluding deleted /
 * blocked statuses). The business is resolved from the staff-token actor on
 * the comm-gw side, so this call takes no parameters.
 *
 * @returns {Promise<Array<object>>} Channel rows: { uid, status, display_name,
 *   open_channel, app_uid, business_uid, intercepted_by_receptionist }
 */
async function listChannels() {
  const res = await gatewayService.get(BASE);
  return unwrapList(res);
}

/**
 * Toggle the AI Chat Receptionist intercept flag on a single channel. The
 * caller must be a staff token belonging to the channel's business; comm-gw
 * enforces the ownership check and rejects any other field on this path.
 *
 * @param {string} channelUid - Channel uid (uuid)
 * @param {boolean} interceptedByReceptionist - true to intercept, false to release
 * @returns {Promise<object>} The updated channel row.
 */
async function setIntercept(channelUid, interceptedByReceptionist) {
  const res = await gatewayService.put(`${BASE}/${encodeURIComponent(channelUid)}`, {
    intercepted_by_receptionist: Boolean(interceptedByReceptionist),
  });
  return unwrapChannel(res);
}

export default {
  listChannels,
  setIntercept,
};
